import { trackUser } from '@api/tracking/client';
import { useEffect } from 'react';
import { useMobileIntentOnboardingRollout } from './experiments';

const DESKTOP_ONBOARDING_PATH = '/app/onboarding';
const MOBILE_ONBOARDING_PATH = '/app/welcome';

export const useOnboardingPageRouting = (): {
  onboardingPath: string;
} => {
  //TODO: remove this when the rollout is completed
  const shouldShowMobileIntentOnboarding = useMobileIntentOnboardingRollout();

  useEffect(() => {
    try {
      trackUser({
        event: 'User received onboarding path',
        properties: {
          isInMobileOnboarding: shouldShowMobileIntentOnboarding,
          onboardingPath: shouldShowMobileIntentOnboarding
            ? MOBILE_ONBOARDING_PATH
            : DESKTOP_ONBOARDING_PATH,
        },
      });
    } catch (error) {
      // Ensure it will not break the app if tracking fails
    }
  }, [shouldShowMobileIntentOnboarding]);

  if (shouldShowMobileIntentOnboarding) {
    return {
      onboardingPath: MOBILE_ONBOARDING_PATH,
    };
  } else
    return {
      onboardingPath: DESKTOP_ONBOARDING_PATH,
    };
};
